// extracted by mini-css-extract-plugin
export default {"lead":"styles_lead__ENr-O","callout":"styles_callout__Nrmlt","calloutIcon":"styles_calloutIcon__mlKwH","calloutText":"styles_calloutText__QrOBV","footer":"styles_footer__lUsyr"};